// import Vue from 'vue';
export default {
    name : 'zoom',

    init()
    {
        const instances = document.querySelectorAll('.zoom--vue');

        for (let i=0; i<instances.length; i++) {
            if (typeof instances[i].dataset.json !== 'undefined') {
                const data = JSON.parse(instances[i].dataset.json);
                if (data && typeof data === 'object') {
                    this.run(data);
                }
            }
        }
    },

    run (data)
    {
        Vue.component('tb-lightbox',
            {
                template: `<div class="zoom__lightbox" :class="active" :id="id" >
                            <div class="zoom__lightbox-inner">
                                <div class="text-right mb-3">
                                        <div class="d-inline-block">
                                        <button type="button" @click="closeLayer" class="btn btn--rounded btn--black btn--centered toggle-layer btn--slim">
                                            <span class="mr-2">Tilbake</span>
                                            <span class="fa-icon">
                                                <svg data-name="Icons/Actions/close/close" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 32 32">
                                                  <defs>
                                                    <clipPath id="clip-path">
                                                      <path id="icon_color" data-name="icon color" d="M9.414,8,16,1.414,14.586,0,8,6.586,1.414,0,0,1.414,6.586,8,0,14.586,1.414,16,8,9.414,14.586,16,16,14.586,9.414,8Z" transform="translate(8 8)" fill="#242424"/>
                                                    </clipPath>
                                                  </defs>
                                                  <g data-name="Group 4">
                                                    <path id="icon_color-2" data-name="icon color" d="M9.414,8,16,1.414,14.586,0,8,6.586,1.414,0,0,1.414,6.586,8,0,14.586,1.414,16,8,9.414,14.586,16,16,14.586,9.414,8Z" transform="translate(8 8)" fill="#242424"/>
                                                  </g>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <img :src="imagesrc"  alt="TODO" title="TODO" />
                                </div>
                            </div>`,

                methods: {
                    closeLayer ()
                    {
                        this.$emit('close');
                    }
                },

                props : ['imagesrc', 'id', 'active'],

                data: function()
                {
                    return {}
                }

            }
        );


        new Vue({
            el: '.zoom--vue',
            data : data,
            methods:
            {
                toggleLightBox (event)
                {
                    document.getElementById(this.id).classList.toggle('active');
                    return false;
                },
            },

            created ()
            {
                // console.log('zoom created');
            }
        });
    }

}